module.exports = __webpack_public_path__ + "img/beer_thumbnail-600x450.6a9c6ae5.jpg";